import { render, staticRenderFns } from "./_siteHeader.vue?vue&type=template&id=00c8edec&scoped=true"
import script from "./_siteHeader.vue?vue&type=script&lang=js"
export * from "./_siteHeader.vue?vue&type=script&lang=js"
import style0 from "./_siteHeader.vue?vue&type=style&index=0&id=00c8edec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8edec",
  null
  
)

export default component.exports